<h2>Mentions légales</h2>

<form [formGroup]="legalNoticesForm" (ngSubmit)="onSubmit()" *ngIf="legalNoticesForm && !isLoading">
  <h4>Mentions légales pour le devis</h4>
  <div class="angularEditor">
    <angular-editor formControlName="legalNoticeQuote" [config]="editorConfigQuote"></angular-editor>
  </div>


  <h4>Mentions légales pour la facture</h4>
  <div class="angularEditor">
    <angular-editor formControlName="legalNoticeInvoice" [config]="editorConfigInvoice"></angular-editor>
  </div>


  <div class="btn_action">
    <button type="button" class="back" (click)="dialogRef.close()">Annuler</button>
    <button type="submit" class="confirm"> Valider</button>
  </div>

</form>

<mat-spinner *ngIf="isLoading" [diameter]="75"></mat-spinner>
